import AppRoutes from "libs/routes";

const App = () => <AppRoutes />;

export default App;
